import i18n from "@/i18n"
import React from "react"
import styled from "styled-components"

const CardWrapper = styled.article`
    display: flex;
    min-width: 240px;
    align-items: center;
    gap: 8px;
    margin: auto 0;
`

const IconContainer = styled.figure`
    border-radius: 12px;
    background-color: #f6f6f6;
    display: flex;
    min-height: 100px;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 100px;
    margin: auto 0;
`

const ContentWrapper = styled.div`
    align-self: stretch;
    display: flex;
    flex-direction: column;
    justify-content: center;
`

const HeaderGroup = styled.header`
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 800;
    line-height: 1;
`

const StepNumber = styled.div`
    border-radius: 999px;
    display: flex;
    align-items: center;
    overflow: hidden;
    font-size: 16px;
    color: #fff;
    text-align: center;
    letter-spacing: -0.32px;
    justify-content: center;
    width: 39px;
`

const StepNumberText = styled.span`
    flex: 1;
    background-color: #222;
    color: white;
    width: 100%;
    padding: 4px;
`

const StepTitle = styled.h3`
    color: #222;
    font-size: 18px;
    letter-spacing: -0.9px;
    margin: 0;
`

const StepDescription = styled.p`
    color: #515151;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: -0.32px;
    margin: 4px 0 0;
    text-align: left;
`

const Container = styled.section`
    background-color: #fff;
    display: flex;
    width: 900px;
    max-width: 100%;
    flex-direction: column;
    overflow: hidden;
    align-items: center;
    padding: 80px 0 20px;
`

const Header = styled.h1`
    color: #222;
    letter-spacing: -0.68px;
    text-align: center;
    font: 700 34px/44px;
    margin: 0;
`

const Highlight = styled.span`
    color: #83c308;
`

const StepsContainer = styled.div`
    display: flex;
    margin-top: 20px;
    min-height: 151px;
    align-items: center;
    gap: 20px;
    justify-content: center;
    flex-wrap: wrap;
`

function StepCard({ number, title, description, icon }) {
    return (
        <CardWrapper>
            {icon && <IconContainer>{icon}</IconContainer>}
            <ContentWrapper>
                <HeaderGroup>
                    <StepNumber>
                        <StepNumberText>{number}</StepNumberText>
                    </StepNumber>
                    <StepTitle>{title}</StepTitle>
                </HeaderGroup>
                <StepDescription>{description.split('\n').map(desc => (
                    <>
                        <span>{desc}</span>
                        <br />
                    </>
                ))}</StepDescription>
            </ContentWrapper>
        </CardWrapper>
    )
}

export default function GuideSection() {
    const steps = [
        {
            number: '01',
            title: i18n.t("common.landing.guide.step.title_1"),
            description: i18n.t("common.landing.guide.step.des_1"),
            icon: <img src="https://front.videomonster.com/images-7cuytg20/common/newlanding2024/guide_item_1.png" alt="템플릿 선택 아이콘" loading="lazy" />
        },
        {
            number: '02',
            title: i18n.t("common.landing.guide.step.title_2"),
            description: i18n.t("common.landing.guide.step.des_2"),
            icon: <img src="https://front.videomonster.com/images-7cuytg20/common/newlanding2024/guide_item_2.png" alt="템플릿 선택 아이콘" loading="lazy" />
        },
        {
            number: '03',
            title: i18n.t("common.landing.guide.step.title_3"),
            description: i18n.t("common.landing.guide.step.des_3"),
            icon: <img src="https://front.videomonster.com/images-7cuytg20/common/newlanding2024/guide_item_3.png" alt="템플릿 선택 아이콘" loading="lazy" />
        }
    ];
    return (
        <Container>
            <Header>
                <Highlight>{i18n.t("common.landing.guide.text_1")}</Highlight>
                <br />
                {i18n.t("common.landing.guide.text_2")}
            </Header>
            <StepsContainer>
                {steps.map((step, index) => (
                    <StepCard key={index} {...step} />
                ))}
            </StepsContainer>
        </Container>
    );
};